export class ReliabilityRogueUpdateModel {
  public Id?: number;
  public GoodsRcvdBatch?: number;
  public ReportId?: number;
  public AfterRemovalOrderType?: string;
  public AfterRemovalOrderNumber?: number;
  public AfterRemovalOrderStatus?: string;
  public AfterRemovalVendorType?: string;
  public AfterRemovalVendor?: string;
  public AfterRemovalCondition?: string;
  public AfterRemovalDate?: Date;
  public RogueStatus?: number;
  public IsFiveConsecutiveAvg?: boolean;
  public IsThreeConsecutive?: boolean;
  public AverageFlightHourForFiveConsecutive?: number;
  public Reason?: number;
  public OtherReason?: string;
}
